import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import * as ajustesApi from '../../api/ajustesEstoque';
import * as estoqueApi from '../../api/estoque';
import { useExigeEmpresaEspecifica } from '../../hooks/useExigeEmpresaEspecifica';
import AvisoSelecioneEmpresa from '../../components/common/AvisoSelecioneEmpresa';
import PageHeader from '../../components/common/PageHeader';
import LoadingSpinner from '../../components/common/LoadingSpinner';
import SearchableSelect from '../../components/common/SearchableSelect';
import { todayIso } from '../../utils/date';
import { TIPOS_AJUSTE } from '../../utils/storeflowOpcoes';
import { getErrorMessage } from '../../utils/apiError';

export default function AjusteNovo() {
  const navigate = useNavigate();
  const { bloqueado, carregandoEmpresas, semEmpresaCadastrada } = useExigeEmpresaEspecifica();
  const [loading, setLoading] = useState(true);
  const [salvando, setSalvando] = useState(false);
  const [erro, setErro] = useState('');
  const [estoque, setEstoque] = useState([]);

  const [idItemLote, setIdItemLote] = useState('');
  const [quantidade, setQuantidade] = useState('');
  const [tipo, setTipo] = useState('perda');
  const [descricao, setDescricao] = useState('');
  const [dataAjuste, setDataAjuste] = useState(todayIso());

  useEffect(() => {
    if (bloqueado) {
      setLoading(false);
      return;
    }
    estoqueApi
      .listEstoque()
      .then((r) => setEstoque(r.data))
      .catch(() => setErro('Erro ao carregar estoque.'))
      .finally(() => setLoading(false));
  }, [bloqueado]);

  const itemInfo = estoque.find((i) => i.id_item_lote === idItemLote);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErro('');
    if (itemInfo && Number(quantidade) > Number(itemInfo.saldo_atual)) {
      setErro(`Quantidade maior que o saldo disponível (${Number(itemInfo.saldo_atual)} ${itemInfo.unidade_sigla}).`);
      return;
    }
    setSalvando(true);
    try {
      await ajustesApi.createAjuste({
        id_item_lote: idItemLote,
        quantidade: Number(quantidade),
        tipo,
        descricao: descricao || null,
        data_ajuste: dataAjuste,
      });
      navigate('/ajustes');
    } catch (err) {
      setErro(getErrorMessage(err, 'Erro ao salvar ajuste.'));
    } finally {
      setSalvando(false);
    }
  };

  if (carregandoEmpresas || loading) return <LoadingSpinner />;

  if (bloqueado) {
    return (
      <div>
        <PageHeader titulo="Novo ajuste de estoque" />
        <AvisoSelecioneEmpresa semEmpresaCadastrada={semEmpresaCadastrada} />
      </div>
    );
  }

  return (
    <div>
      <PageHeader titulo="Novo ajuste de estoque" subtitulo="Registrar perda, quebra ou avaria fora do fluxo normal de saída" />
      <form onSubmit={handleSubmit} className="sf-card p-4" style={{ maxWidth: 640 }}>
        {erro && (
          <div className="sf-login-alert mb-3">
            <i className="bi bi-exclamation-circle" />
            {erro}
          </div>
        )}

        <label className="sf-field-label mb-3">
          <span>Item em estoque</span>
          <SearchableSelect
            options={estoque.map((i) => ({
              value: i.id_item_lote,
              label: `${i.produto_nome} — ${i.qualidade_nome} (Lote ${i.lote_codigo}) — saldo ${Number(i.saldo_atual)} ${i.unidade_sigla}`,
            }))}
            value={idItemLote}
            onChange={setIdItemLote}
            placeholder="Buscar item em estoque..."
            required
          />
        </label>

        <div className="row g-3">
          <div className="col-md-4">
            <label className="sf-field-label">
              <span>Quantidade {itemInfo && `(${itemInfo.unidade_sigla})`}</span>
              <span className="sf-field">
                <input type="number" min="0.001" step="0.001" required value={quantidade} onChange={(e) => setQuantidade(e.target.value)} />
              </span>
            </label>
          </div>
          <div className="col-md-4">
            <label className="sf-field-label">
              <span>Tipo</span>
              <select className="form-select" value={tipo} onChange={(e) => setTipo(e.target.value)}>
                {TIPOS_AJUSTE.map((t) => (
                  <option key={t.value} value={t.value}>{t.label}</option>
                ))}
              </select>
            </label>
          </div>
          <div className="col-md-4">
            <label className="sf-field-label">
              <span>Data</span>
              <span className="sf-field">
                <i className="bi bi-calendar3" />
                <input type="date" required value={dataAjuste} onChange={(e) => setDataAjuste(e.target.value)} />
              </span>
            </label>
          </div>
        </div>

        <div className="mb-3 mt-3">
          <label className="sf-field-label">
            <span>Descrição</span>
            <textarea className="form-control" rows={2} placeholder="Ex: saco rasgado no transporte" value={descricao} onChange={(e) => setDescricao(e.target.value)} />
          </label>
        </div>

        <button type="submit" className="sf-btn sf-btn-primary" disabled={salvando || !idItemLote}>
          {salvando ? 'Salvando...' : 'Registrar ajuste'}
        </button>
      </form>
    </div>
  );
}
